import { Modal } from "@/shared/ui";
import PlayerMenuSettingsSafetyDisableTfaSMSCheckContainer from "@/domains/playerMenu/containers/settings/safety/tfa/check-disable/PlayerMenuSettingsSafetyDisableTfaSMSCheckContainer";

type Props = {
  onClose: () => void;
};

export default function PlayerMenuSettingsSafetyDisableTfaSMSContainer({ onClose }: Props) {
  return (
    <Modal open onClose={onClose} title="Отключение 2FA SMS" className="h-[49rem]">
      <PlayerMenuSettingsSafetyDisableTfaSMSCheckContainer onClose={onClose} />
    </Modal>
  );
}
